export class LoginModel {
    telefone: string;
    senha: string;
}